import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LayoutFinish from '../components/LayoutFinish/LayoutFinish';
import Finish from '../components/Finish/Finish';

import { resetStep } from '../actions/card';
import Layout from "../components/Layout/Layout";

class FinishScreen extends Component {

  render() {

    return(
      <Layout page="finish">
        <Finish />
      </Layout>
    )
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  resetStep
}, dispatch);
  
export default connect(mapDispatchToProps)(FinishScreen);